import { useContext, useEffect, useState } from "react"
import { isClient as isWindowClient } from "@/app/configs"
import { AppContext } from "@/app/context"
interface ThothanInputs {
  userToken: string
  userName: string
  isDev: boolean
}

interface ThothanConfig {
  token: string
  baseUrl: string
  inputs: ThothanInputs
}

// Extend Window interface to include Thothan config
declare global {
  interface Window {
    thothanChatbotConfig?: ThothanConfig
    initializeECVBot?: (config: {
      loadingMessage: string
      botId: string
      clientToken: string
    }) => void
    _chatbotLoaded?: boolean
  }
}

const ThothanChatbot = () => {
  const [isClient, setIsClient] = useState(false)
  const { userInfo, scriptLoaded, setScriptLoaded } = useContext(AppContext)
  const token = isWindowClient ? window.localStorage.getItem("token") : null

  // Function to initialize the chatbot
  const initializeChatbot = () => {
    if (!isClient || !scriptLoaded || !token || !userInfo?.userid) {
      console.log("Cannot initialize chatbot - prerequisites not met")
      return
    }

    if (window.initializeECVBot) {
      try {
        window.initializeECVBot({
          loadingMessage: "Gamee đang suy nghĩ...",
          botId: "2utVcA058QmDKavBHk0jVyydWoI",
          clientToken: token
        })
        // console.log("Chatbot initialization successful")
      } catch (error) {
        console.error("Error initializing chatbot:", error)
      }
    }
  }

  useEffect(() => {
    if (isWindowClient) {
      setIsClient(true)
    }
  }, [isClient])

  useEffect(() => {
    if (isClient && token && userInfo?.userid) {
      loadChatbotScript()
    }
  }, [isClient, token, userInfo])

  useEffect(() => {
    if (isClient && scriptLoaded && token && userInfo?.userid) {
      initializeChatbot()
    }
  }, [isClient, scriptLoaded, token, userInfo])

  const loadChatbotScript = () => {
    delete window.initializeECVBot
    delete window._chatbotLoaded

    setScriptLoaded(false)

    const existing = document.getElementById("ecv-bot-script")
    if (existing) {
      existing.remove()
    }

    const script = document.createElement("script")
    script.id = "ecv-bot-script"
    script.src = "https://d1ah0sokb5vwhz.cloudfront.net/ecv-bot-embedded.js"
    script.async = true
    script.onload = () => {
      window._chatbotLoaded = true
      setScriptLoaded(true)
    }
    script.onerror = (e) => {
      console.error("Error loading chatbot script:", e)
    }

    document.body.appendChild(script)
  }

  if (!isWindowClient || !token) return null

  return (
    <>
      <style jsx global>{`
        #ecv-bot-iframe-root {
          bottom: 80px !important;
        }

        @media (max-width: 768px) {
          #ecv-bot-iframe-root {
            bottom: 100px !important;
          }
        }
      `}</style>
      {/* <Script
        src="https://d1ah0sokb5vwhz.cloudfront.net/ecv-bot-embedded.js"
        onLoad={() => {
          console.log("Chatbot script loaded successfully")
          setScriptLoaded(true)
        }}
        onError={(e) => {
          console.error("Error loading chatbot script:", e)
        }}
      /> */}
    </>
  )
}

export default ThothanChatbot
